import { Button, Group } from "@mantine/core";
import { useDispatch } from "react-redux";

import { useRuleQuery } from "../../../components/QueryBuilder/hooks/useRuleQuery";
import { triggerApplyFilter } from "../../../redux/features/advancedSearch/advancedSearchSlice";
import SaveFilterModal from "./SaveFilterModal";
import SaveReportModal from "./SaveReportModal";

export default function SearchHeader({ ruleId }) {
  const dispatch = useDispatch();
  const { data: rule } = useRuleQuery(ruleId);

  return (
    <Group justify="flex-end" gap="md">
      <Button
        variant="filled"
        color="primary.7"
        onClick={() => dispatch(triggerApplyFilter())}
      >
        Apply filter
      </Button>
      <SaveFilterModal ruleId={ruleId} defaultName={rule?.name ?? ""} />
      {rule && rule.type !== "BASIC" && (
        <SaveReportModal
          ruleId={ruleId}
          defaultName={rule.name ?? ""}
          disabled={rule.hasSavedData === true}
        />
      )}
    </Group>
  );
}
